{
  "title": "mapIcons",
  "type": "array",
  "uniqueItems": true,
  "items": {
    "title": "mapIcon",
    "type": "object",
    "properties": {
      "id": {
        "description": "The unique identifier for a map icon",
        "type": "integer",
        "minimum": 0
      },
      "name": {
        "description": "The name of a map icon",
        "type": "string"
      },
      "appearance": {
        "description": "Description of the map icon's appearance",
        "type": "string"
      },
      "visibleInItemFrame": {
        "description": "Visibility in item frames",
        "type": "boolean"
      }
    },
    "required": ["id", "name", "visibleInItemFrame"],
    "additionalProperties": false
  }
}
